import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';

import {
    MOD_STATE,
} from '../../../utils/constants';
import { getDetailsUrl, pushHistoryWithPage } from '../../../utils/routing';
//import { getUserRole } from '../../../utils/functions';

import ActionCancelMod from '../../ActionCancelMod/ActionCancelMod';
import ActionHiddenMod from '../../ActionHiddenMod/ActionHiddenMod';
import ActionVisibleMod from '../../ActionVisibleMod/ActionVisibleMod';
import Caption from '../../Caption/Caption';
import ModState from '../../ModState/ModState';
import Select from '../../Select/Select';
import ActionViewMod from '../../ActionViewMod/ActionViewMod';

import {
    EDIT_STATE_LABEL,
} from './translations';

import styles from './EditState.module.css';

export default class EditState extends React.PureComponent {
    static propTypes = {
        id: PropTypes.number,
        isHidden: PropTypes.bool.isRequired,
        isViewModLinkEnabled: PropTypes.bool.isRequired,
        state: PropTypes.number.isRequired,
        onModVisibilityChange: PropTypes.func.isRequired,
        onUpdateCancel: PropTypes.func.isRequired,
        onUpdateReject: PropTypes.func,

        history: ReactRouterPropTypes.history.isRequired,
    }

    handleModVisibilitySet = () => {
        this.props.onModVisibilityChange(true)
    }

    handleModVisibilityClear = () => {
        this.props.onModVisibilityChange(false)
    }

    handleModViewClick = () => {
        debugger
        pushHistoryWithPage(this.props.history, getDetailsUrl(this.props.id))
    }

    renderActionVisibility() {
        if ([MOD_STATE.REJECTED, MOD_STATE.DRAFT, MOD_STATE.IN_REVIEW].includes(this.props.state)) {
            return null
        }

        return this.props.isHidden ? (
            <div className={styles.action}>
                <ActionVisibleMod onClick={this.handleModVisibilitySet} />
            </div>
        ) : (
            <div className={styles.action}>
                <ActionHiddenMod onClick={this.handleModVisibilityClear} />
            </div>
        )
    }

    renderViewModLink() {
        if (!this.props.isViewModLinkEnabled) {
            return null
        }

        return (
            <div className={styles.action}>
                <ActionViewMod onClick={this.handleModViewClick} />
            </div>
        )
    }

    renderActionCancelUpdate() {
        if (document.location.pathname.includes('/review/')) {
            return [MOD_STATE.IN_REVIEW, MOD_STATE.PUBLISHED_UPDATE_IN_REVIEW].includes(this.props.state) ? (
                <div className={styles.action}>
                    <ActionCancelMod onClick={this.props.onUpdateReject} />
                </div>
            ) : null
        } else {
            return [MOD_STATE.IN_REVIEW, MOD_STATE.PUBLISHED_UPDATE_IN_REVIEW].includes(this.props.state) ? (
                <div className={styles.action}>
                    <ActionCancelMod onClick={this.props.onUpdateCancel} />
                </div>
            ) : null
        }
    }

    handleStateModChange = () => {
        return
    }

    renderFilterSelect = () => {
        const modStateItems = [
            {value: 0, caption: "Черновик"},
            {value: 1, caption: "Проверяется"},
            {value: 2, caption: "Отклонено"},
            {value: 3, caption: "Опубликовано"},
            {value: 4, caption: "Обновление проверяется"},
            {value: 5, caption: "Обновление отклонено"},
            {value: 6, caption: "Скрыт"}
        ];
        /*
        .map((item) => ({
                            value: item.id,
                            caption: item.lang,
                        }))
                            */

        return (
            <div className={styles.fieldSelect}>
                <div className={styles.selectSelect} id={this.props.state} >
                    <Select
                        items={modStateItems}
                        selectedValue={this.props.state} 
                        onItemChange={this.handleStateModChange}
                    />
                </div>
            </div>
        )
    }

    renderActions() {
        //return getUserRole() === 'robot' ? this.renderFilterSelect() 
        return (
            <>
            {this.renderActionVisibility()}
            {this.renderViewModLink()}
            {this.renderActionCancelUpdate()}
            </>
        )
    }

    render() {
        return (
            <div className={styles.base}>
                <div className={styles.label}>
                    <Caption isLarge>
                        {EDIT_STATE_LABEL()}<ModState isHidden={this.props.isHidden} state={this.props.state} />
                        {/* {EDIT_STATE_LABEL(<ModState isHidden={this.props.isHidden} state={this.props.state} />)} */}
                    </Caption>
                </div>
                <div className={styles.field}>
                    {this.renderActions()}
                </div>
            </div>
        )
    }
}
